import { render } from "./Keypoints.vue?vue&type=template&id=41f735bb&scoped=true"
import script from "./Keypoints.vue?vue&type=script&lang=js"
export * from "./Keypoints.vue?vue&type=script&lang=js"

import "./Keypoints.vue?vue&type=style&index=0&id=41f735bb&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-41f735bb"

export default script